function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#bfe1ff",
  r: 256
}))))))), /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0-4.15-.099-8.277-.294-12.379l-127.143-127.143-228.078 223.949 111.75 111.751-6.235 12.584 42.625 42.626c118.131-22.715 207.375-126.629 207.375-251.388z",
  fill: "#87c7ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m377.518 342.59c22.219-33.665 44.771-79.302 44.771-122.824 0-88.525-71.764-160.289-160.289-160.289s-160.289 71.764-160.289 160.289 71.764 160.29 160.289 160.29v84.706s83.265-73.303 115.518-122.172z",
  fill: "#06b26b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m262 59.477c-1.969 0-3.927.048-5.88.119v320.342c1.952.07 3.91.118 5.88.118v84.706s83.265-73.303 115.518-122.172c22.219-33.665 44.771-79.302 44.771-122.824 0-88.525-71.764-160.289-160.289-160.289z",
  fill: "#0a9154"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.455 171.525-36.875 15.317v-13.981c0-8.433-6.836-15.27-15.27-15.27h-138.545c-8.433 0-15.27 6.836-15.27 15.27v84.791c0 8.433 6.836 15.27 15.27 15.27h138.547c8.433 0 15.27-6.836 15.27-15.27v-13.981l36.875 15.317v-87.463z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m333.581 186.843v-13.981c0-8.433-6.836-15.27-15.27-15.27h-62.191v115.33h62.191c8.433 0 15.27-6.836 15.27-15.27v-13.981l36.875 15.317v-87.463z",
  fill: "#e9edf5"
})));

function SvgHangoutsMeet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangoutsMeet);
export default __webpack_public_path__ + "static/media/hangouts-meet.d061189e.svg";
export { ForwardRef as ReactComponent };